import { useEffect } from 'react'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Place from '@material-ui/icons/Place'
import DirectionsWalk from '@material-ui/icons/DirectionsWalk'

import StandardReportForm from './excel'

export default function ReportCard({
	quarter,
	// Main Component's State
	flags,
	type,
	preField,
	onFillForm,
	// Standard Report Answers
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	user,
}) {
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [type])

	const isFixed = type.includes('fixed')
	const Icon = isFixed ? Place : DirectionsWalk
	const reportLabel = isFixed ? 'แบบประจำที่ (Fixed)' : 'แบบเคลื่อนที่ (Mobile)'

	return (
		<Card className="border border-t-4 border-card_top_border border-l-0 border-r-0 border-b-0">
			<CardContent className="flex flex-col gap-y-3 w-full">
				<Grid component="div" className="flex flex-row gap-x-3">
					<Grid
						component="div"
						className="font-bold flex flex-row items-center">
						<Icon style={{ fontSize: 22 }} className="mr-1" />
						<Grid className="font-bold text-sm text-card_header_color">
							{reportLabel}
						</Grid>
					</Grid>
				</Grid>
				<Divider />
				<Grid className="py-5">
					<StandardReportForm
						quarter={quarter}
						flags={flags}
						type={type}
						preField={preField}
						onFillForm={onFillForm}
						fixedGeneralAnswers={fixedGeneralAnswers}
						fixedInfoAnswers={fixedInfoAnswers}
						fixedSoundAnswers={fixedSoundAnswers}
						mobileGeneralAnswers={mobileGeneralAnswers}
						mobileInfoAnswers={mobileInfoAnswers}
						mobileSoundAnswers={mobileSoundAnswers}
						user={user}
					/>
				</Grid>
			</CardContent>
		</Card>
	)
}
